import { render } from "./AdminWebinarPage.vue?vue&type=template&id=bdf0e1b2"
import script from "./AdminWebinarPage.vue?vue&type=script&lang=js"
export * from "./AdminWebinarPage.vue?vue&type=script&lang=js"

import "./AdminWebinarPage.vue?vue&type=style&index=0&id=bdf0e1b2&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__